<!-- Color -->
<div class="background-color-picker">
  <div
    class="background-color-picker-input form-group"
    style="position: relative"
  >
    <color-picker
      pickerId="backgroundColor"
      [(ngModel)]="background.color"
      ngDefaultControl
    ></color-picker>
  </div>
</div>

<!-- Image Choice -->
<div class="form-group">
  <div class="flex-row">
    <mat-checkbox
      #backgroundUseImage
      name="visibility"
      id="backgroundUseImage"
      ngDefaultControl
      (ngModelChange)="useImageChange($event)"
      [ngModel]="background.useImage"
    >
    </mat-checkbox>
    <label
      id="backgroundUseImageLabel"
      for="backgroundUseImage-input"
      (click)="useImageChange(!background.useImage)"
      >Use Image</label
    >
  </div>
</div>

@if (background.useImage && background.image) {
  <div id="backgroundImageControls">
    <!-- Image Placeholder -->
    <div class="form-group">
      @if (!imageLoaded) {
        <div class="image-placeholder">
          <i class="fa fa-image"></i>
        </div>
      }
      <!-- Image -->
      <div [shown]="imageLoaded" class="row">
        <div class="col-xs-4">
          <img
            [src]="imageUrl"
            (error)="imageLoaded = false"
            alt="Background image preview"
            class="img-rounded img-responsive"
          />
        </div>
      </div>
    </div>
    <!-- Image URL -->
    <rv-url-field
      id="backgroundImageUrl"
      name="imageUrl"
      #urlField="ngModel"
      ngDefaultControl
      [class.big-error-text]="urlField.control.hasError('httpUrl')"
      [(ngModel)]="background.image.url"
      (ngModelChange)="setImageUrl($event)"
      urlPatternValidator
      httpValidator
      urlFileTypeValidator
      acceptedFileTypes="IMAGES"
      required
    />

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label
            id="background-image-position-label"
            class="control-label"
            for="background-image-position"
            >Image Position:</label
          >
          <mat-form-field appearance="outline">
            <mat-select
              id="background-image-position"
              name="position"
              [(ngModel)]="background.image.position"
              aria-labelledby="background-image-position-label"
            >
              <mat-option value="top-left">Top Left</mat-option>
              <mat-option value="top-center">Top Center</mat-option>
              <mat-option value="top-right">Top Right</mat-option>
              <mat-option value="middle-left">Middle Left</mat-option>
              <mat-option value="middle-center">Middle Center</mat-option>
              <mat-option value="middle-right">Middle Right</mat-option>
              <mat-option value="bottom-left">Bottom Left</mat-option>
              <mat-option value="bottom-center">Bottom Center</mat-option>
              <mat-option value="bottom-right">Bottom Right</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label
            id="background-image-repeat-label"
            class="control-label"
            for="background-image-repeat"
            >Image Repeat:</label
          >
          <mat-form-field appearance="outline">
            <mat-select
              id="background-image-repeat"
              name="repeat"
              [(ngModel)]="background.image.repeat"
              aria-labelledby="background-image-repeat-label"
              [disabled]="background.image.scale"
            >
              <mat-option value="no-repeat">None</mat-option>
              <mat-option value="repeat-y">Vertical</mat-option>
              <mat-option value="repeat-x">Horizontal</mat-option>
              <mat-option value="repeat">Both</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <!-- Scale to fit -->
    <div class="form-group">
      <div class="flex-row">
        <mat-checkbox
          name="scale"
          ngDefaultControl
          [(ngModel)]="background.image.scale"
          >Scale To Fit</mat-checkbox
        >
      </div>
    </div>
  </div>
}
